import { BackTop } from "../back-top/back-top";

export class Footer {
  constructor() {
    // this.backTop = new BackTop();
  }
}
